// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TopNavMenuBar-module_top_nav_light_giLKW {
  padding-left: 0px !important;
  padding-right: 20px !important;
}

.TopNavMenuBar-module_top_nav_dark_dGH7k {
  background-color: var(--main-nav-bg-color) !important;
  color: white;
}

.TopNavMenuBar-module_nav_button_IswmP {
}

.TopNavMenuBar-module_nav_button_dark_NzbbP {
}

.TopNavMenuBar-module_nav_selected_TBQTz {
}

.TopNavMenuBar-module_nav_selected_dark_mxR9w {
}

.TopNavMenuBar-module_nav_more_menu_button_vUHnM {
  cursor: pointer;
}

.TopNavMenuBar-module_nav_right_group_rSN3C {
  gap: 12px;
}

.TopNavMenuBar-module_divider_ZZedx {
  height: 65%;
  border-left-color: rgba(255, 255, 255, 0.7);
}

.TopNavMenuBar-module_avatar_circle_RuEyf {
  display: inline-block;
  margin-right: 4px;
  font-size: 20px;
  font-weight: 700;
  border-radius: 36px;
  line-height: 36px;
  height: 36px;
  width: 36px;
  text-align: center;
  background: var(--site-avatar-color) !important;
  color: white !important;
}

.TopNavMenuBar-module_welcome_text_dn8fM {
  font-size: 20px;
  margin-right: 8px;
}

.TopNavMenuBar-module_chevron_icon_abJuj {
  padding-bottom: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Navigation/TopNavMenuBar.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EAEE,qDAAqD;EACrD,YAAY;AACd;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".top_nav_light {\n  padding-left: 0px !important;\n  padding-right: 20px !important;\n}\n\n.top_nav_dark {\n  composes: top_nav_light;\n  background-color: var(--main-nav-bg-color) !important;\n  color: white;\n}\n\n.nav_button {\n  composes: nav_button from 'Styles/styles.module.css';\n}\n\n.nav_button_dark {\n  composes: nav_button_dark from 'Styles/styles.module.css';\n}\n\n.nav_selected {\n  composes: nav_button_selected from 'Styles/styles.module.css';\n}\n\n.nav_selected_dark {\n  composes: nav_button_selected_dark from 'Styles/styles.module.css';\n}\n\n.nav_more_menu_button {\n  cursor: pointer;\n}\n\n.nav_right_group {\n  gap: 12px;\n}\n\n.divider {\n  height: 65%;\n  border-left-color: rgba(255, 255, 255, 0.7);\n}\n\n.avatar_circle {\n  display: inline-block;\n  margin-right: 4px;\n  font-size: 20px;\n  font-weight: 700;\n  border-radius: 36px;\n  line-height: 36px;\n  height: 36px;\n  width: 36px;\n  text-align: center;\n  background: var(--site-avatar-color) !important;\n  color: white !important;\n}\n\n.welcome_text {\n  font-size: 20px;\n  margin-right: 8px;\n}\n\n.chevron_icon {\n  padding-bottom: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"top_nav_light": `TopNavMenuBar-module_top_nav_light_giLKW`,
	"top_nav_dark": `TopNavMenuBar-module_top_nav_dark_dGH7k TopNavMenuBar-module_top_nav_light_giLKW`,
	"nav_button": `TopNavMenuBar-module_nav_button_IswmP ${___CSS_LOADER_ICSS_IMPORT_0___.locals["nav_button"]}`,
	"nav_button_dark": `TopNavMenuBar-module_nav_button_dark_NzbbP ${___CSS_LOADER_ICSS_IMPORT_0___.locals["nav_button_dark"]}`,
	"nav_selected": `TopNavMenuBar-module_nav_selected_TBQTz ${___CSS_LOADER_ICSS_IMPORT_0___.locals["nav_button_selected"]}`,
	"nav_selected_dark": `TopNavMenuBar-module_nav_selected_dark_mxR9w ${___CSS_LOADER_ICSS_IMPORT_0___.locals["nav_button_selected_dark"]}`,
	"nav_more_menu_button": `TopNavMenuBar-module_nav_more_menu_button_vUHnM`,
	"nav_right_group": `TopNavMenuBar-module_nav_right_group_rSN3C`,
	"divider": `TopNavMenuBar-module_divider_ZZedx`,
	"avatar_circle": `TopNavMenuBar-module_avatar_circle_RuEyf`,
	"welcome_text": `TopNavMenuBar-module_welcome_text_dn8fM`,
	"chevron_icon": `TopNavMenuBar-module_chevron_icon_abJuj`
};
export default ___CSS_LOADER_EXPORT___;
